export const CompositionUpdate = 'compositionUpdate'
export const ContentEditableInput = 'contentEditableInput'
export const Delete = 'delete'
export const DeleteHorizontalRight = 'deleteHorizontalRight'
export const EditorPasteText = 'editorPasteText'
export const EditorSnippet = 'editorSnippet'
export const Format = 'format'
export const IndentLess = 'indentLess'
export const IndentMore = 'indentMore'
export const InsertLineBreak = 'insertLineBreak'
export const ToggleBlockComment = 'toggleBlockComment'
export const EditorType = 'editorType'
export const EditorCut = 'editorCut'
